export default __webpack_public_path__ + "static/media/edit profile.a604eee7.jpg";